import React, { Fragment, SFC } from 'react';
import PaymentLoader from './PaymentLoader/index';
import Translate from 'components/Translate';

// tslint:disable-next-line:variable-name
export const PaymentInProgress: SFC = () => {
  return (
    <Fragment>
      <div className="progressMessage">
        <Translate term={'Estamos processando seu pagamento...'} />
      </div>
      <PaymentLoader />
    </Fragment>
  );
};
